import { useState } from 'react';
import FloatingChatButton from './FloatingChatButton';
import ChatBotWindow from './ChatBotWindow';

/**
 * ChatBot - Main chatbot component that manages state for button and window
 */
function ChatBot() {
  const [isOpen, setIsOpen] = useState(false);

  const toggleChat = () => {
    setIsOpen((prev) => !prev);
  };

  return (
    <>
      <ChatBotWindow isOpen={isOpen} />
      <FloatingChatButton isOpen={isOpen} onClick={toggleChat} />
    </>
  );
}

export default ChatBot;

